import { Box } from "@/components/ui/box";
import { SafeAreaView } from "@/components/ui/safe-area-view";
import { VStack } from "@/components/ui/vstack";
import Logo from "@/screens/menu/logo/logo";
import { Slot } from "expo-router";
import { useColorScheme } from "@/components/useColorScheme";
import { ColorSchemeName } from "react-native";
import { ScrollView } from "@/components/ui/scroll-view";

export default function InvitationLayout() {
  const colorScheme: ColorSchemeName = useColorScheme();

  return (
    <SafeAreaView className="w-full h-full bg-background-0">
      <VStack className="w-full h-full items-center p-4 gap-4">
        <Box className="w-32 h-10 self-start md:self-auto">
          <Logo
            color={colorScheme === "dark" ? "white" : "black"}
            fill={colorScheme === "dark" ? "white" : "black"}
            width="100%"
            height="100%"
          />
        </Box>
        <ScrollView
          className="w-full h-full max-w-screen-sm"
          contentContainerClassName="grow p-1"
          alwaysBounceVertical={false}
        >
          <Slot />
        </ScrollView>
      </VStack>
    </SafeAreaView>
  );
}
